(function(){
    'use strict';

    // Global variables
    var squiz = {
        'fn': {},
        'vars': {
            'scrollingFromNavClick': false ,
        }
    };

    // Functions
    squiz.fn.setScrollingFromNav = function() {
        squiz.vars.scrollingFromNavClick = true;
    };

    squiz.fn.setScrollingFromNavComplete = function() {
        squiz.vars.scrollingFromNavClick = false;
    };

    // Make squiz variable available to the console for debugging
    window.squiz = squiz;


    //Polyfill for IE11 Closest
    if (!Element.prototype.matches) {
        Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
    }
    
    if (!Element.prototype.closest) {
        Element.prototype.closest = function(s) {
        var el = this;
    
        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
        };
    }



    // REMOVE BEFORE MOVING TO MATRIX
    //var elem = document.querySelector('.exit-survey');
    //elem.parentNode.removeChild(elem);
    // REMOVE BEFORE MOVING TO MATRIX
}());



